import { createBrowserRouter, RouterProvider } from "react-router-dom";
import Home from "./pages/Home";
import "./assets/css/theme.css";
import { useEffect, useState } from "react";
import Sig from "./pages/Sig";
import Dash from "./pages/Dash";
import Balance from "./pages/Balance";
import Stats from "./pages/Stats";
import Indicator from "./pages/Indicator";
import New from "./pages/New";
import Map from "./pages/Map";
import { LanguageContext } from "./config/multilingualContext";
import { SelectedCountryProvider } from "./contexts/SelectedCountryContext";
import { CountryDataProvider } from "./contexts/CountryDataContext";
import CookieConsent from "./components/CookieConsent";
import { listIndi, setToken, setTokenLog } from "./functions";
import { setTokenLogin } from "./api";
import axios from "axios";
import Flux from "./pages/Flux";

function App() {
  var userLang = navigator.language || navigator.userLanguage;
  const [language, setLanguage] = useState(process.env.REACT_APP_LANG || "french");
  const [loggedIn, setLoggedIn] = useState(
    sessionStorage.getItem("loggedIn") === "true" || false
  );

  function toggleLanguage(lang) {
    setLanguage(lang);
  }

  useEffect(() => {
    /*async function login() {
            const response = await setTokenLogin();
            if (response?.status === 204) {
                setLoggedIn(true);
                sessionStorage.setItem('loggedIn', true);
            }
        }
       const token = localStorage.getItem('token');
       if (!token) {
           login();
       }*/
  }, []);

  return (
    <LanguageContext.Provider value={{ language, toggleLanguage }}>
      <SelectedCountryProvider>
        <CountryDataProvider>
          {/* use createBrowserRouter and opt-in to v7_startTransition future flag */}
          {(() => {
            const router = createBrowserRouter(
              [
                { path: '/', element: <Home /> },
                { path: '/dashboard', element: <Dash /> },
                { path: '/sig', element: <Sig /> },
                { path: '/sankey', element: <Flux /> },
                { path: '/balance', element: <Balance /> },
                { path: '/indicator', element: <Indicator /> },
                { path: '/stats', element: <Stats /> },
                { path: '/map', element: <Map /> },
                { path: '/new/:id', element: <New /> },
                { path: '*/*', element: <Home /> },
                { path: '*', element: <Home /> },
              ],
              { future: { v7_startTransition: true } }
            );
            return (
              <div className="app">
                <RouterProvider router={router} />
                <CookieConsent position="left" />
              </div>
            );
          })()}
        </CountryDataProvider>
      </SelectedCountryProvider>
    </LanguageContext.Provider>
  );
}

export default App;
